export const GET_USER = "Get User"
export const FETCH_USER_SUCCESS = "Get User success"
export const FETCH_USER_FAILURE = "Get User failure"
export const GET_USER_COMPANIES = "Get User Companies"
export const FETCH_USER_COMPANIES_SUCCESS = "Get User Companies success"
export const FETCH_USER_COMPANIES_FAILURE = "Get User Companies failure"
export const CHANGE_COMPANY = "Change Company"
export const CHANGE_COMPANY_SUCCESS = "Change Company success"
export const CHANGE_COMPANY_FAILURE = "Change Company success"
export const GET_USER_SETTING = "Get user setting"
export const FETCH_USER_SETTING_SUCCESS = "Get User setting success"
export const FETCH_USER_SETTING_FAILURE = "Get User setting failure"

export const FETCH_VESSEL_WATCHlIST = "Get vessel watchlists"
export const FETCH_VESSEL_WATCHlIST_SUCCESS = "Get vessel watchlists success"
export const FETCH_VESSEL_WATCHlIST_FAILURE = "Get vessel watchlists failure"

export const SAVE_CURRENT_COMPANY = "save current company id"
export const SAVE_CURRENT_COMPANY_SUCCESS = "save current company id success"
export const SAVE_CURRENT_COMPANY_FAILURE = "save current company id failure"

export const loadUser = (data) => ({
  type: GET_USER,
});

export const getUserCompanies = (data) => ({
  type: GET_USER_COMPANIES,
});

export const getUserSetting = (data) => ({
  type: GET_USER_SETTING,
  payload: data
});

export const changeCompany = (company) => ({
  type: CHANGE_COMPANY,
  companyId: company.id,
  company: company
});

export const getVesselWatchLists= () => ({
  type: FETCH_VESSEL_WATCHlIST,
});

export const saveCurrentCompany = (data) => ({
  type: SAVE_CURRENT_COMPANY,
  payload: data
});